/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Attention Data API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../runtime';
import type { BrandedMomentsRequestDto } from './BrandedMomentsRequestDto';
import {
    BrandedMomentsRequestDtoFromJSON,
    BrandedMomentsRequestDtoFromJSONTyped,
    BrandedMomentsRequestDtoToJSON,
} from './BrandedMomentsRequestDto';

/**
 *
 * @export
 * @interface UpdateCreativeRequestDto
 */
export interface UpdateCreativeRequestDto {
    /**
     *
     * @type {Array<BrandedMomentsRequestDto>}
     * @memberof UpdateCreativeRequestDto
     */
    brandedMoments?: Array<BrandedMomentsRequestDto> | null;
    /**
     *
     * @type {string}
     * @memberof UpdateCreativeRequestDto
     */
    name?: string | null;
    /**
     *
     * @type {number}
     * @memberof UpdateCreativeRequestDto
     */
    duration?: number;
}

/**
 * Check if a given object implements the UpdateCreativeRequestDto interface.
 */
export function instanceOfUpdateCreativeRequestDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateCreativeRequestDtoFromJSON(json: any): UpdateCreativeRequestDto {
    return UpdateCreativeRequestDtoFromJSONTyped(json, false);
}

export function UpdateCreativeRequestDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UpdateCreativeRequestDto {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        brandedMoments: !exists(json, 'branded_moments')
            ? undefined
            : json['branded_moments'] === null
            ? null
            : (json['branded_moments'] as Array<any>).map(BrandedMomentsRequestDtoFromJSON),
        name: !exists(json, 'name') ? undefined : json['name'],
        duration: !exists(json, 'duration') ? undefined : json['duration'],
    };
}

export function UpdateCreativeRequestDtoToJSON(value?: UpdateCreativeRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        branded_moments:
            value.brandedMoments === undefined
                ? undefined
                : value.brandedMoments === null
                ? null
                : (value.brandedMoments as Array<any>).map(BrandedMomentsRequestDtoToJSON),
        name: value.name,
        duration: value.duration,
    };
}
